import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import translationEN from "./en/translation.json";
import translationFR from "./fr/translation.json";
export var resources = {
    fr: {
        translation: translationFR,
    },
    en: {
        translation: translationEN,
    },
};
i18next
    .use(initReactI18next) // passes i18n down to react-i18next
    .init({
    resources: resources,
    defaultNS: "translation",
    lng: getLanguage(),
    interpolation: {
        escapeValue: false, // react already safes from xss
    },
});
export function getLanguage() {
    return localStorage.getItem("lang") || "fr";
}
export function setLanguage(lang) {
    localStorage.setItem("lang", lang);
}
export default i18next;
